import { promosSelector } from './promosSelector';
import { IApplicationState } from '../types/redux';

export const hasMortgagePromosSelector = (state: IApplicationState): boolean => {
  const promos = promosSelector(state);

  return promos.length > 0;
};
